module.exports = __webpack_public_path__ + "img/17.a40e0734.png";